// import path from 'path';
// import manifest from '../../manifest.json';
//
// const { pdfTemplateUrl } = manifest;

export default class MobileNavModel {
    constructor({ regionModel, linksModel, pagesModel }) {
        this.regionModel = regionModel;
        this.linksModel = linksModel;
        this.pagesModel = pagesModel;
        this.findButton = { id: 'find', label: 'find place', icon: 'search', toast: null };
        this.buttons = [
            this.findButton,
            { id: 'menu', label: 'menu' },
        ];
        this.selected = null;
    }

    // Must be called after makeReactive
    init() {
        this.regionModel.$watch('region', newRegion => {
            if (newRegion && this.selected === this.findButton.id) {
                this.selected = null;
                document.body.style.overflowY = 'scroll';
            }
        });
        this.regionModel.$watch('loading', loading => {
            if (this.selected === this.findButton.id && loading === null && !this.regionModel.searchError) {
                this.selected = null;
            }
        });
        this.linksModel.$watch('link', newLink => {
            if (newLink) {
                this.selected = null;
            }
        });
        this.pagesModel.$watch('currentPage', newPage => {
            if (newPage) {
                this.selected = null;
            }
        });
    }

    get region() {
        return this.regionModel.region;
    }

    get localName() {
        return this.region && this.region.localName;
    }
}
